import { formatMoney } from '~/helpers'

import { formatMetrics } from '../../common/metrics'

export const formatGroceryListAdvertisers: FormatAdvertisersList = data =>
  data.map(advertiser => ({
    _raw: {
      originPath: 'src/modules/retailMedia/dtos/grocery/advertiser/list.ts'
    },
    id: advertiser.id,
    advertiserTags: advertiser?.advertiser_tags,
    checkingAccountId: advertiser.checking_account_id,
    balance: formatMoney(advertiser.metrics.balance),
    title: advertiser.name,
    sellerId: advertiser.seller_id,
    metrics: {
      ...formatMetrics({ data: advertiser.metrics })
    },
    logo_url: advertiser.account_logo,
    account_theme: { ...advertiser.account_theme }
  }))
